export default class ActionsRenderer {
  // This renderer creates buttons for the actions column. It only handles routes with a single :id. Nested routes with
  // multiple ids are not supported
  init (params) {
    this.eGui = document.createElement("span")
    const buttons = params.value.map(button => {
      if (button.name === "Delete") {
        return `<a class='btn btn-grid btn-${button.class}' href='${button.url.replace(":id", params.data.id)}' data-method='delete' data-confirm='Are you sure?' ${button.remote ? "data-remote=\"true\"" : ""}>${button.name}</a>`
      } else {
        return `<a class='btn btn-grid btn-${button.class}' href='${button.url.replace(":id", params.data.id)}'>${button.name}</a>`
      }
    })

    this.eGui.innerHTML = buttons.join(" ")
  }

  getGui () {
    return this.eGui
  }

  refresh () {
    return false
  }
}
